module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Winterthur-2ad16e3a51b78199ea733920b5d38dd8.svg";